import { Dialog, DialogContent } from "@mui/material";
import React from "react";

let key = 0;
const Details = ({
  open,
  handleClose,
  name,
  technology,
  desc,
  liveSite,
  clientCode,
  serverCode,
}) => {
  const projectDetails = desc.split(":");
  const techs = technology.split(",");

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      scroll={"paper"}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
    >
      <h5 className="px-3 font-semibold text-white">{name}</h5>
      <hr />
      <DialogContent>
        <div>
          <h6 className="font-medium primary-text">Project Details</h6>
          <ul className="text-white" style={{ listStyleType: "disc" }}>
            {projectDetails.map((projectDetail) => (
              <li key={key++}>{projectDetail}</li>
            ))}
          </ul>
        </div>

        <h6 className="font-medium primary-text mt-2"> Technologies </h6>
        <div className="mt-2">
          {techs.map((tech) => (
            <button
              key={key++}
              className="px-3 mr-2 mb-2 text-white primary-border font-medium rounded-full"
            >
              {tech}
            </button>
          ))}
        </div>

        <div className="mt-3">
          {liveSite && (
            <a href={liveSite} target="blank" className="text-decoration-none">
              <button className="primary-btn px-3 py-1 mr-2 rounded-full font-semibold">
                Live Preview
              </button>
            </a>
          )}
          <a href={clientCode} target="blank" className="text-decoration-none">
            <button className="primary-btn rounded-full font-semibold px-3 py-1 mr-2">
              Client Code
            </button>
          </a>
          {serverCode && (
            <a
              href={serverCode}
              target="blank"
              className="text-decoration-none"
            >
              <button className="primary-btn rounded-full font-semibold px-3 py-1 mr-2">
                Server Code
              </button>
            </a>
          )}
          <button
            className="primary-btn rounded-full font-semibold px-3 py-1"
            onClick={handleClose}
          >
            Close
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default Details;
